(() => {
  let _bundleCartHandler = null;

  class BundleFilters extends HTMLElement {
    constructor() {
      super();

      this.collection = document.querySelectorAll("collection-grid [data-product-item]");
      this.types = Array.from(this.querySelectorAll("[data-bundle-type]")).filter(
        (el) => !el.dataset.bonus
      );
      this.notifications = document.querySelectorAll("bundle-cart-notification");
      this.bundle = [];

      const firstEmpty = Array.from(this.types).find(t => t.dataset.empty);
      if (firstEmpty) {
        this.types.forEach(t => {
          t.toggleAttribute("data-active", t === firstEmpty);
        });
      }

      const activeType = this.querySelector("[data-bundle-type][data-active]")?.dataset?.bundleType;
      this.showProducts(activeType);

      this.types.forEach(card => {
        if (!card.dataset.empty) {
          this.bundle.push({ id: card.id, type: card.dataset.bundleType, variant: null });
        }

        card.addEventListener("click", () => {
          this.types.forEach(c => c.toggleAttribute("data-active", c === card));
          this.showProducts(card.dataset.bundleType);
        });
      });

      this.notifications.forEach(notification => {
        if (notification.dataset.next) {
          const modal = notification.closest("modal-element");
          if (!modal) return;
          modal.addEventListener("click", () => {
            modal._close();
            this.types.forEach(c => {
              c.toggleAttribute("data-active", c.dataset.bundleType === notification.dataset.next);
            });
            this.showProducts(notification.dataset.next);
          });
        }
      });

      this.setupQuickAddBundleAttribute();

      if (_bundleCartHandler) {
        document.removeEventListener("cart-add-bundle", _bundleCartHandler);
      }
      _bundleCartHandler = (event) => {
        const quickAddModal = document.querySelector('modal-element[data-name="quick-add"]');
        if (quickAddModal) quickAddModal._close();

        this.renderProduct(event.detail.variant, event.detail.types);
        this.updateCartCount();
        this.refreshBundleSection();
      };
      document.addEventListener("cart-add-bundle", _bundleCartHandler);
    }

    setupQuickAddBundleAttribute() {
      const quickAddModal = document.querySelector('modal-element[data-name="quick-add"]');
      if (!quickAddModal || quickAddModal.dataset.bundleForm !== "true") return;

      const observer = new MutationObserver(() => {
        const submitBtn = quickAddModal.querySelector('[type="submit"][data-add-to-cart]');
        if (submitBtn && !submitBtn.dataset.bundle) {
          submitBtn.setAttribute("data-bundle", "true");
        }
      });

      observer.observe(quickAddModal.querySelector("quick-add-content"), {
        childList: true,
        subtree: true
      });
    }

    showProducts(type) {
      if (!this.collection.length) return;
      let card = this.querySelector(`[data-bundle-type="${type}"]`);
      if (!card && (type === "basebonus" || type === "Type_Baselayer")) {
        card = Array.from(this.querySelectorAll("[data-bundle-type]")).find(
          (c) => (c.dataset.bundleHeading || "").toLowerCase().includes("base layer")
        );
      }
      const filterTypes = card?.dataset.filterTypes
        ? card.dataset.filterTypes.split(",").map((s) => s.trim().toLowerCase()).filter(Boolean)
        : [type.toLowerCase()];
      const heading = (card?.dataset.bundleHeading || "").toLowerCase();
      if (heading && !filterTypes.includes(heading)) filterTypes.push(heading);
      Array.from(this.collection).forEach(el => {
        const typesStr = (el.dataset.types || "").toLowerCase();
        const matches = typesStr && filterTypes.some(ft => typesStr.includes(ft));
        if (matches) {
          el.removeAttribute("data-hide");
        } else {
          el.setAttribute("data-hide", true);
        }
      });
    }

    renderProduct(variant, types) {
      const typesArr = Array.isArray(types) ? types : (typeof types === "string" ? types.split(",").map(s => s.trim()) : []);
      const typesLower = typesArr.map(t => String(t).toLowerCase());
      const typeMatches = (card) => {
        const bt = (card.dataset.bundleType || "").toLowerCase();
        const heading = (card.dataset.bundleHeading || "").toLowerCase();
        const filterTypes = (card.dataset.filterTypes || "").split(",").map(s => s.trim().toLowerCase()).filter(Boolean);
        if (typesLower.some(t => t.includes(bt) || bt.includes(t))) return true;
        if (heading && typesLower.some(t => t.includes(heading) || heading.includes(t))) return true;
        if (filterTypes.length && typesLower.some(t => filterTypes.some(ft => t.includes(ft) || ft.includes(t)))) return true;
        return false;
      };
      const matchedCard = Array.from(this.types).find(card =>
        card.dataset.empty !== undefined && typeMatches(card)
      ) || Array.from(this.types).find(card =>
        parseInt(card.dataset.variantId) === variant.id
      );

      if (matchedCard) {
        matchedCard.removeAttribute("data-empty");
        matchedCard.dataset.variantId = variant.id;

        const quickAdd = document.querySelector("quick-add-content");
        const img = quickAdd?.querySelector("img");
        const imageContainer = matchedCard.querySelector("[data-image]");
        if (img && imageContainer) {
          imageContainer.innerHTML = img.outerHTML;
        }

        const selectedText = matchedCard.querySelector(".group-data-\\[empty\\]\\/card\\:hidden");
        if (selectedText) selectedText.classList.remove("hidden");
      }

      let notificationShown = false;
      this.notifications.forEach(notification => {
        if (notificationShown) return;

        const card = matchedCard;
        if (!card) return;

        const cardKey = card.id.split("bundle-filter-")[1];
        const notifKey = notification.id.split("bundle-notification-")[1];

        if (cardKey === notifKey) {
          notificationShown = true;
          notification.renderNotification();
        }
      });

      const nextEmpty = Array.from(this.types).find(t => t.dataset.empty !== undefined);
      if (nextEmpty) {
        this.types.forEach(c => {
          c.toggleAttribute("data-active", c === nextEmpty);
        });
        this.showProducts(nextEmpty.dataset.bundleType);
      }
    }

    updateCartCount() {
      fetch("/cart.js")
        .then(r => r.json())
        .then(cart => {
          const hasItems = cart.item_count > 0;

          document.querySelectorAll("[data-cart-count]").forEach(el => {
            el.dataset.cartCount = cart.item_count;
            el.classList.toggle("_cart-count-not-zero", hasItems);
          });

          document.querySelectorAll("._dot").forEach(dot => {
            dot.style.display = hasItems ? "" : "none";
          });

          document.querySelectorAll("._cart-icon-btn")?.forEach(el => {
            const iconWrapper = el.previousElementSibling;
            if (iconWrapper) {
              iconWrapper.classList.toggle("_cart-count-not-zero", hasItems);
              if (hasItems && !iconWrapper.querySelector("._dot")) {
                const dot = document.createElement("div");
                dot.className = "_dot absolute rounded-full -bottom-0.5 -right-[3px] w-2 h-2 bg-black";
                iconWrapper.appendChild(dot);
              }
            }
          });
        })
        .catch(() => {});
    }

    refreshBundleSection() {
      const section = this.closest("section") || this.closest("[id^='shopify-section-']");
      if (!section) return;
      const sectionId = section.id?.replace("shopify-section-", "");
      if (!sectionId) return;

      const openModal = section.querySelector("modal-element._cart-notification[open]");
      const openModalId = openModal?.id;

      const url = `${window.location.pathname}?sections=${sectionId}`;
      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          const html = data[sectionId];
          if (!html) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newSection = doc.querySelector("[id^='shopify-section-']") || doc.body.firstElementChild;
          if (newSection && section.parentNode) {
            section.replaceWith(newSection);

            if (openModalId) {
              requestAnimationFrame(() => {
                const restoredModal = document.getElementById(openModalId);
                if (!restoredModal) return;
                const notif = restoredModal.querySelector("bundle-cart-notification");
                if (notif) {
                  notif.renderNotification();
                } else {
                  restoredModal._open();
                }
              });
            }
          }
        })
        .catch(() => {});
    }
  }

  customElements.define("bundle-filters", BundleFilters);

  class BundleCartNotification extends HTMLElement {
    constructor() {
      super();
      this.modal = this.parentElement;
      this.index = parseInt(this.dataset.index);
      this._boundClose = this.close.bind(this);
      this._autoCloseTimer = null;
      this._clickHandler = null;
    }

    open() {
      if (this.modal && typeof this.modal._open === "function") this.modal._open();
    }

    close() {
      if (this._autoCloseTimer) {
        clearTimeout(this._autoCloseTimer);
        this._autoCloseTimer = null;
      }
      if (this._clickHandler) {
        document.removeEventListener("click", this._clickHandler);
        this._clickHandler = null;
      }
      if (this.modal && typeof this.modal._close === "function") this.modal._close();
    }

    renderNotification() {
      if (this._autoCloseTimer) clearTimeout(this._autoCloseTimer);
      if (this._clickHandler) {
        document.removeEventListener("click", this._clickHandler);
        this._clickHandler = null;
      }

      this.open();

      this._autoCloseTimer = setTimeout(() => this.close(), 15000);

      setTimeout(() => {
        this._clickHandler = (e) => {
          if (!e.target.closest("modal-element")) this.close();
        };
        document.addEventListener("click", this._clickHandler, { once: true });
      }, 2000);
    }
  }

  customElements.define("bundle-cart-notification", BundleCartNotification);
})();
